<div>
    <a class="btn btn-link btn-icon btn-icon--left btn-back" [routerLink]="['/home']">
        {{ 'back' | translate }}
    </a>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title">
                        {{content[locale]?.title}}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-block card--box__block" *ngIf="content[locale]">
            <div [innerHTML]="content[locale]?.content | safeHtml"></div>
        </div>
    </div>
</div>